import { useAtomValue } from "jotai";

import { standardPlacementResizeActiveAtom } from "@design-lab/entities/artwork";
import { useApplyStandardPlacement } from "@design-lab/shared/lib/config";

/**
 * MN-8890 — Print PDP notice telling the customer their artwork is auto-resized to the standard
 * print dimensions per garment size. Flag-gated (`print_size_standard_placement`) AND gated on an
 * actual resize being active (usePrintStandardPlacementResize sets the atom): it renders only when
 * a per-size standard is genuinely applied, so it never over-promises on mixed/unmapped orders the
 * resolver defers. Copy is signed off by Joe (comment 246918).
 */
export function StandardPlacementNotice() {
  const enabled = useApplyStandardPlacement();
  const resizeActive = useAtomValue(standardPlacementResizeActiveAtom);
  if (!enabled || !resizeActive) return null;

  return (
    <p data-testid="standard-placement-notice" className="mt-2 text-sm text-gray-600">
      Your artwork will be automatically resized to our standard print dimensions for each garment
      size in your order.
    </p>
  );
}
